import { PATHS, PROJECT_PATHS } from "@/routing/paths"

export const getProjectOfferLinkSheet = <TProject extends { id: string }>(
  project?: TProject | null
) => {
  return `${PATHS.PROPERTIES}${PROJECT_PATHS.OFFER}/${project?.id ?? "0"}`
}
